import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * Layout: child routes `/forgot-password/verify` need {@link Outlet} to render OTP / recovery steps.
 */
const ForgotPasswordLayout = () => <Outlet />;

export const Route = createFileRoute("/_auth/forgot-password")({
    component: ForgotPasswordLayout,
});
